<template >
    <a-modal :class="mbxs?'mb2':''" v-model="visable" title="授权" ok-text="确认" @cancel="closeWzj" cancel-text="取消" @ok="submitForm" width="800px">
      <j-form-container :disabled="formDisabled" >
        <a-form :form="form" slot="detail">
            <a-row style="width:50%;float:left;">
              <a-col :span="24" style="text-align:center;line-height:50px">
                <label>账户一</label>
              </a-col>
              <a-col :span="24">
                <a-form-item label="账户" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-decorator="['usernameOne', validatorRules.usernameOne]" placeholder="请输入账户"></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item label="密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input type="password" v-decorator="['passwordOne', validatorRules.passwordOne]" placeholder="请输入密码"></a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row style="width:50%;float:left;">
                <a-col :span="24" style="text-align:center;line-height:50px">
                  <label>账户二</label>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="账户" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['usernameTwo', validatorRules.usernameTwo]" placeholder="请输入账户"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input type="password" v-decorator="['passwordTwo', validatorRules.passwordTwo]" placeholder="请输入密码"></a-input>
                  </a-form-item>
                </a-col>
              </a-row>
        </a-form>
      </j-form-container>
    </a-modal>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import Vue from 'vue'

  export default {
    name: 'UnitForm',
    components: {
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    inject:['closeCurrent'],
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        visable:false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          usernameOne: {
            rules: [
              { required: true, message: '请输入账户名!'},
            ]
          },
          passwordOne: {
            rules: [
              { required: true, message: '请输入密码!'},
            ]
          },
          usernameTwo: {
            rules: [
              { required: true, message: '请输入账户名!'},
            ]
          },
          passwordTwo: {
            rules: [
              { required: true, message: '请输入密码!'},
            ]
          },
        },
        url: {
          add: "/sys/authorization/verification",
          edit: "/jwbd/unit/edit",
          queryById: "/jwbd/unit/query/by/id"
        },
        idNumber:'',
        captchaType:'',
        toUrl:'',
        mbxs:false
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      
      add (record) {
        if("RWHX_AUTHORIZATION_USERNAME"!=record.captchaType){
          this.mbxs=true;
        }else{
          this.mbxs=false;
        }
        this.idNumber=record.idNumber;
        this.captchaType=record.captchaType;
        this.toUrl=record.toUrl;
        this.visable = true;
      },
      
      //渲染流程表单数据
      showFlowData(){
        
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            formData.captchaType=this.captchaType;
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                res.result.idNumber=that.idNumber;
                res.result.toUrl=that.toUrl;
                that.$emit('ok',res.result);
                if(res.result.ifJump=='1'){
                  that.mbxs=false;
                  that.visable=false; 
                }
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'usernameOne','passwordOne','usernameTwo','passwordTwo'))
      },
      closeWzj(){
        this.mbxs=false;
        if("RWHX_AUTHORIZATION_USERNAME"!=this.captchaType){
          this.closeCurrent(); 
        }
      }
    }
  }
</script>
<style>
</style>
<style>
  .mb2::after{
    content: "";
    position: absolute;
    width: 100%;
    height: 88%;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-45%);
    background: #f2ffff;
    z-index: 10;
  }
</style>